import { useIsPredictionsProduct } from '@/hooks/use-is-predictions-product';

import { getPotentialPayoutWithBonus } from '../utils/bet-promo-utils';
import { getPredictionBetPayout } from '../utils/prediction-cost';
import { Bet } from './types';

// Potential payout of an open bet: the filled contract count for predictions (once the order fills), stake times odds otherwise.
export const usePotentialPayout = (bet: Bet): number => {
    const isPredictions = useIsPredictionsProduct();
    const predictionPayout = isPredictions ? getPredictionBetPayout(bet) : undefined;
    return predictionPayout ?? getPotentialPayoutWithBonus(bet);
};
